// Agent avaibility page.

const configContents = ({ state: { langStrings }, dispatch }) => (
  [
    {
      isTitle: true,
      isAgentAvailable: true,
      description: langStrings
        ? langStrings.contactOptions.agentAvailableStdby
        : "Agent is Available - Stand by",
      id: 'adsk-page-title',
      // Below is the format to remove red warnings in Chrome.
      style: {
        'margintop': '-50px !important',
        'marginleft': '10px',
        'marginbottom': '0px'
      }
    },
    {
      description: langStrings
        ? langStrings.contactOptions.connectMomentarily
        : 'You will be connected momentarily.',
      paragraphStyle: { marginBottom: '20px' },
    },
    {
      description: langStrings
        ? langStrings.contactOptions.popUpBlocker + ' ' + langStrings.contactOptions.forceStartChat
        : 'Have a pop-up blocker?',
      paragraphStyle: { marginBottom: '20px' },
    },
    {
      description: langStrings
        ? langStrings.contactOptions.note + ' ' + langStrings.contactOptions.closingWindowMsg
        :'NOTE',
      style: { fontSize: '12px', color: '#666' },  
      paragraphStyle: { 
        marginTop: '55%'
      },
    }
  ]);

const configFooter = ({
  state: {
    langStrings
  },
  dispatch,
}) => ({
  nextButtonContent: langStrings ? langStrings.buttons.closeButton : 'CLOSE',
  handleNext: () => {
    dispatch({ type: 'RESTART_WIDGET' })
    window.location.reload(true);
  },
  handleBack: () => {
    dispatch({ type: 'GO_TO_PREV_PAGE' });
  },
});

export default {
  configContents,
  configFooter,
};
